import { FirmUser } from '../FirmUserAccess/FirmUserAccessPage';
import { UserAccessLogEntry } from '../FirmUserAccess/firmUserAccessLog';
import { AdvisorViewTarget } from '../openAdvisorView';

export type UserAccessAccount = {
  kind: 'advisor' | 'firm';
  name: string;
  sub: string | null;
  accessTypeLabel: string;
  isOwner: boolean;
  isClientOnly: boolean;
  distroAccountUserId: string | null;
  distroId: string | null;
  healthClaimDistroId: string | null;
  advisorId: string | null;
  canView: boolean;
};

export type UserAccessProfile = {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  userType: 'Advisor' | 'Non-Advisor';
  accounts: UserAccessAccount[];
};

export type UserAccessHistoryEntry = UserAccessLogEntry & {
  accountName: string;
  healthClaimDistroId: string | null;
};

export const viewTarget = (account: UserAccessAccount): AdvisorViewTarget | null => {
  if (!account.canView) return null;
  if (account.kind === 'advisor' && account.advisorId) return { advisorId: account.advisorId };
  if (account.kind === 'firm' && account.distroAccountUserId) return { distroAccountUserId: account.distroAccountUserId };
  return null;
};

export const toFirmDistro = (account: UserAccessAccount) => ({
  id: account.distroId ?? '',
  name: account.name,
  healthClaimDistroId: account.healthClaimDistroId ?? '',
});

export const toFirmUser = (profile: UserAccessProfile, account: UserAccessAccount): FirmUser => ({
  id: account.distroAccountUserId,
  firstName: profile.firstName,
  lastName: profile.lastName,
  email: profile.email,
  isOwner: account.isOwner,
  isClientOnly: account.isClientOnly,
  isAdvisor: profile.userType === 'Advisor',
  accessTypeLabel: account.accessTypeLabel,
});

export const accessTagStyle: React.CSSProperties = {
  display: 'inline-block', padding: '3px 10px', borderRadius: 20, fontSize: 11.5, fontWeight: 600,
  whiteSpace: 'nowrap', background: '#E0F2FE', color: '#075985', border: '0.5px solid #7DD3FC',
};

export const accountLineStyle: React.CSSProperties = {
  display: 'flex', alignItems: 'center', minHeight: 28,
};
